import React from 'react'
import Confirm from 'views/confirm/confirm'
import { connect } from 'react-redux'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'

import pollActions from 'redux/actions/pollActions'
import { localize } from 'helpers/translator'

const PollCancelConfirm = props => (
	<Confirm
		btOne={localize('global_no')}
		btTwo={localize('global_yes')}
		alertMessage={localize('poll_cancelConfirm')}
		actionButtonType={0}
		actionOne={() => {
			props.actions.cancelReject()
		}}
		actionTwo={() => props.actions.cancelConfirm()}
		closeAction={() => props.actions.cancelReject()}
	/>
)

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		cancelReject: pollActions.cancelReject,
		cancelConfirm: pollActions.cancelConfirm,
	}, dispatch)
}

export default connect(null, mapDispatchToProps)(PollCancelConfirm)

export { PollCancelConfirm }
